// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see QRCodeScannerViewOpenEvent
 */
export var QRCodeScannerViewOpen = function (_a) {
    var loadTimeMs = _a.loadTimeMs;
    return ({
        name: "QRCodeScanner View Open",
        parameters: {
            cdf_entity: "QRCodeScanner",
            cdf_action: "View",
            load_time_ms: loadTimeMs !== undefined && loadTimeMs !== null ? loadTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see QRCodeScannerScanCompleteEvent
 */
export var QRCodeScannerScanComplete = function (_a) {
    var category = _a.category, isValid = _a.isValid;
    return ({
        name: "QRCodeScanner Scan Complete",
        parameters: {
            cdf_entity: "QRCodeScanner",
            cdf_action: "Scan",
            category: category !== undefined && category !== null ? category.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_valid: isValid !== undefined && isValid !== null ? isValid.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
